import s from './List.scss'
import MaterialTable from '@material-table/core'
import { timezoneDate } from 'utils/helpers'
import { FaClone } from 'react-icons/fa'

const columns = [
  { title: 'Name', field: 'title', defaultSort: 'asc' },
  { title: 'Created By', field: 'createdBy' },
  {
    title: 'Created On',
    field: 'createdOn',
    render: row => timezoneDate(row.createdOn, 'hh:mm A')
  },
  { title: 'Last Modified By', field: 'lastModifiedBy' },
  {
    title: 'Last Modified On',
    field: 'lastModifiedOn',
    render: row => timezoneDate(row.lastModifiedOn, 'hh:mm A')
  }
]

const List = ({ templates, deleteTemplate, openEditModal, cloneTemplate }) => {
  return (
    <div className={s.listWrapper} data-cy="templates_table_wrapper">
      <MaterialTable
        title="Current Proposal Templates:"
        columns={columns}
        data={templates}
        options={{
          actionsColumnIndex: -1,
          sorting: true,
          headerStyle: {
            backgroundColor: '#eee',
            color: '#000',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '14px'
          },
          maxBodyHeight: '400px',
          pageSize: 20,
          padding: 'dense'
        }}
        style={{
          boxShadow: 'none',
          fontSize: '14px'
        }}
        actions={[
          () => ({
            icon: 'edit',
            tooltip: 'Edit Template',
            onClick: (event, rowData) => openEditModal(rowData)
          }),
          () => ({
            icon: () => <FaClone />,
            tooltip: 'Clone Template',
            onClick: (event, rowData) => cloneTemplate(rowData.id)
          }),
          () => ({
            icon: 'delete',
            tooltip: 'Delete Template',
            onClick: (event, rowData) => deleteTemplate(rowData.id),
            disabled: templates.length === 1
          })
        ]}
      />
    </div>
  )
}

export default List
